import { AccommodationList, Response } from '@data/models';
import Store from '@data/stores/Store';
import { apiCall } from '../axios';
export class AccommodationsService {
    static search(params) {
        Store.environment.setCurrencyRate(0);
        return new Promise((resolve, reject) => {
            const url = '/rooms';
            apiCall(Response)('post', url, Object.assign(Object.assign({}, params), { currency_code: params.currency_code.toUpperCase() }))
                .then((res) => {
                const rawAccommodationList = Object.assign({}, res);
                const accommodationList = new AccommodationList(rawAccommodationList, {
                    isUsingNewAmenitiesSystem: Store.property.amenities.isUsingNewAmenitiesSystem,
                });
                accommodationList.checkin = params.checkin;
                accommodationList.checkout = params.checkout;
                Store.environment.setCurrencyRate(accommodationList.currency_rate || 1);
                resolve(accommodationList);
            })
                .catch(reject);
        });
    }
}
